module.exports = __webpack_public_path__ + "static/media/icons.97493d3f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/icons/icons.woff2
// module id = 427
// module chunks = 0